import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import ScrollableWithGradients from "./ScrollableWithGradients";

const USER_TYPE_FILTER_OPTIONS = [
  { value: "", label: "All types" },
  { value: "superuser", label: "superuser" },
  { value: "admin", label: "admin" },
  { value: "teacher", label: "teacher" },
  { value: "student", label: "student" },
  { value: "outwrite", label: "outwrite" },
  { value: "outwrite_learner", label: "outwrite_learner" },
];

const UserList = ({
  users = [],
  selectedUser,
  selectedUsers,
  setSelectedUsers,
  handleSelectedUser = () => {},
  handleSelectedUsers = () => {},
  multiselect = false,
  typeIsActive = false,
  deletedStatusIsActive = false,
  activeStatusIsActive = false
}) => {

  const containerRef = useRef(null);
  const [typeFilter, setTypeFilter] = useState("");

  const visibleUsers = useMemo(() => {
    if (!typeIsActive || !typeFilter) return users;
    return users.filter((user) => user.type === typeFilter);
  }, [users, typeIsActive, typeFilter]);

  useEffect(() => {
    if (!typeIsActive || !typeFilter || !selectedUser) return;
    if (selectedUser.type !== typeFilter) {
      handleSelectedUser(null);
    }
  }, [typeFilter, typeIsActive, selectedUser, handleSelectedUser]);

  const isSelected = (user) =>
    multiselect
      ? selectedUsers.some((u) => u.uid === user.uid)
      : selectedUser?.uid === user.uid;

  const selectUser = (user) => {
    if (multiselect) {
      const already = selectedUsers.some((u) => u.uid === user.uid);
      const newSelected = already
        ? selectedUsers.filter((u) => u.uid !== user.uid)
        : [...selectedUsers, user];
      setSelectedUsers(newSelected);
      handleSelectedUsers(newSelected);
    } else {
      // setSelectedUser(selectedUser === user ? null : user);
      handleSelectedUser(selectedUser === user ? null : user);
    }
  };

  return (

    <Box sx={{ position: "relative", height: "70vh", borderRadius: 3, }}>
      {typeIsActive && (
        <FormControl size="small" sx={{ minWidth: 180, mb: 1.5 }} fullWidth>
          <InputLabel id="users-type-filter-label">User type</InputLabel>
          <Select
            labelId="users-type-filter-label"
            label="User type"
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            {USER_TYPE_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value || "all"} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <ScrollableWithGradients>
        <Stack
          spacing={2}
          ref={containerRef}
        >
          {visibleUsers.map((user) => (
            <Box
              key={user.uid}
              onClick={() => selectUser(user)}
              sx={{ cursor: "pointer" }}
            >
              <Card
                sx={{
                  width: "100%",
                  backgroundColor: isSelected(user) ? "#e8f5e9" : "white",
                  "&:hover": { backgroundColor: isSelected(user) ? "#e8f5e9" : "#e3f2fd" },
                  transition: "background-color 0.3s ease"
                }}
              >
                <CardContent>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Avatar src={user.portrait || undefined}>
                      {user.firstName?.[0]}
                    </Avatar>
                    <Box>
                      <Typography variant="h6">
                        {user.firstName} {user.lastName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {user.email}
                      </Typography>
                      {user.phoneNumber && (
                        <Typography variant="body2" color="textSecondary">
                          {user.phoneNumber}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box mt={1}>
                    {typeIsActive && (
                        <Typography variant="body2" color="textSecondary">
                          [{user.type}]
                        </Typography>
                    )}
                    {deletedStatusIsActive && user.isDeleted && (
                        <Typography variant="body2" color="textSecondary">
                          [deleted]
                        </Typography>
                    )}
                    {activeStatusIsActive && (
                        <Typography variant="body2" color="textSecondary">
                          [{user.isActive ? 'active' : 'inactive'}]
                        </Typography>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Stack>
      </ScrollableWithGradients>
    </Box>
  );
};

export default UserList;